import merge from 'lodash/merge';
import { TFunction } from 'i18next';

import { getDefaultAtpConfig, getTemplateConfig } from './cfg.default';

const cfg = {
  policySubType: 0,
  policyType: 2,
  tmVirusscans: {
    vsFileTagContent: '[MaliciousContent]',
    vsTextTagSubjectContent: 'Suspicious File:',
    vsWormsTrojansActionType: 109,
    vsReplacementText:
      'This file is %Action% because it triggered %FilterName%.\nContact your Cloud App Security administrator for further support or information.',
  },

  tmFileblockings: {
    fbActionType: 109,
    fbFileTagContent: '[FileBlocked]',
  },

  tmWebthreatprotections: {
    wtpExtractAttachmentUrl: 1,
    wtpApprovedHeaderList: '',
    wtpFileTagContent: '[RiskyURLInside]',
  },

  tmDdafilters: {},
};

export function getSharePointTemplateConfig(
  t: TFunction<'translation'>,
  accountEmail: string | undefined
) {
  const coverI18nKeys = [
    'policy.policyTemplate.SPOD.tmVirusscans.vsReplacementText',
    'policy.policyTemplate.SPOD.tmDdafilters.ddaReplacementText',
    'policy.policyTemplate.SPOD.tmFileblockings.fbReplacementFileName',
    'policy.policyTemplate.SPOD.tmFileblockings.fbReplacementText',
    'policy.policyTemplate.SPOD.tmWebthreatprotections.wtpReplacementText',
    'policy.policyTemplate.SPOD.tmVirusscans.vsFileTagContent',
    'policy.policyTemplate.SPOD.tmFileblockings.fbFileTagContent',
    'policy.policyTemplate.SPOD.tmWebthreatprotections.wtpFileTagContent',
  ];
  const ntfI18nReplaceKeys = [
    'policy.policyTemplate.SP.tmFileblockings.notification.ntfAdminMessage',
    'policy.policyTemplate.SP.tmFileblockings.notification.ntfAdminSubject',
    'policy.policyTemplate.SP.tmFileblockings.notification.ntfInternalRecipientMessage',
    'policy.policyTemplate.SP.tmFileblockings.notification.ntfInternalRecipientSubject',
    'policy.policyTemplate.SP.tmVirusscans.notification.ntfAdminMessage',
    'policy.policyTemplate.SP.tmVirusscans.notification.ntfAdminSubject',
    'policy.policyTemplate.SP.tmVirusscans.notification.ntfInternalRecipientMessage',
    'policy.policyTemplate.SP.tmVirusscans.notification.ntfInternalRecipientSubject',
    'policy.policyTemplate.SP.tmWebthreatprotections.notification.ntfAdminMessage',
    'policy.policyTemplate.SP.tmWebthreatprotections.notification.ntfAdminSubject',
    'policy.policyTemplate.SP.tmWebthreatprotections.notification.ntfInternalRecipientMessage',
    'policy.policyTemplate.SP.tmWebthreatprotections.notification.ntfInternalRecipientSubject',
    'policy.policyTemplate.SP.tmDdafilters.notification.ntfAdminMessage',
    'policy.policyTemplate.SP.tmDdafilters.notification.ntfAdminSubject',
    'policy.policyTemplate.SP.tmDdafilters.notification.ntfInternalRecipientMessage',
    'policy.policyTemplate.SP.tmDdafilters.notification.ntfInternalRecipientSubject',
  ];
  const tempConfig = getDefaultAtpConfig();
  merge(tempConfig, cfg);
  return getTemplateConfig(
    t,
    tempConfig,
    accountEmail,
    coverI18nKeys,
    ntfI18nReplaceKeys
  );
}
